<template>
  <transition name="zoom">
    <section class="myModal" v-if="showMyModal">
     <div class="myModalOverlay"></div>
    <div class="myModalBodyOuter">
      <div class="myModalBody">
        <div class="clearfix">
          <b-button @click="exitModal" variant="danger" class="float-right"><i class="fa fa-times-circle" aria-hidden="true"></i> Exit</b-button>
        </div>
        <h3 class="m-t-30">Send Custom Email and SMS notifications</h3>
        <h5 class="m-b-30 text-danger">Orders List: {{ list.name }}</h5>
        <h6>Use dynamic data</h6>
        <ul class="dynamic-data">
          <li 
          v-for="(variable, index) in templateVariables" 
          :key="index" 
          >
          <div v-clipboard:copy="variable.value"
          >
            {{ variable.name }}  <b-icon icon="intersect"></b-icon>
          </div></li>
        </ul>
        <div class="m-b-30">
          <h6>Email Subject</h6>
          <b-form-input v-model="emailSubject"  placeholder="Email Subject" size="lg"></b-form-input>
        </div>
        <h6>Email Body</h6>
        <div class="m-b-30">
          <vue-editor id="emailBodyEditor" :editor-toolbar="customToolbar"  v-model="emailBody" ></vue-editor>
        </div>
        <div class="m-b-30">
          <h6>SMS Body</h6>
          <b-form-textarea
              id="textarea"
              v-model="smsBody"
              placeholder="Enter something..."
              rows="6"
              max-rows="6"
            ></b-form-textarea>
        </div>
        <section class="m-b-30">
            <b-form-checkbox class="m-b-20" v-model="sendTestNotification" name="check-button" switch>
              Test Notification
            </b-form-checkbox>
            <b-row v-if="sendTestNotification">
              <b-col cols="5">
                  <label for="" class="text-small">Test Email ID</label>
                 <b-form-input v-model="test.email" type="email" placeholder="Email Id"></b-form-input>
              </b-col>
              <b-col cols="4">
                  <label for="" class="text-small">Test Phone ID</label>
                 <b-form-input v-model="test.phone"  placeholder="Phone no."></b-form-input>
              </b-col>
              <b-col cols="3">
                 <label for="" class="text-small">Country Code</label>
                 <b-form-input v-model="test.countryCode"  placeholder="Country Code"></b-form-input>
              </b-col>
            </b-row>
        </section>
        <div>
          <b-button variant="primary" block size="lg" @click.prevent="sendNotification">
            <b-spinner small v-show="processing"></b-spinner>
            <span >{{ processing ? "Loading..." : "Send Notification" }}</span>
          </b-button>
        </div>
      </div>
    </div>
    </section>
</transition>
</template>

<script>
import EventBus from '../../../../EventBus';
import { VueEditor  } from "vue2-editor";
import CustomCustomerNotification from '../../../../services/custom-customer-notification.service';

export default {
  props: {
    list: {
      type: Object,
      default: () => ({name: '', value: null})
    }
  },
  mounted(){
    EventBus.$on('show-custom-notification-modal', () => {
       this.showMyModal = true;
       let bodyTag = document.querySelector('body');
       let htmlTag = document.querySelector('html');
       bodyTag.style.overflowY = 'hidden';
       htmlTag.style.overflowY = 'hidden';
    })
  },
  data() {
    return {
      sendTestNotification: false,
      test: {email: '', phone: '', countryCode: 'IN'},
      showMyModal: false,
      emailBody: "",
      smsBody: '',
      emailSubject: '',
      id: null,
      customToolbar: [
        [{ header: [false, 1, 2, 3, 4, 5, 6] }],
        ["bold", "italic", "underline", "strike"], // toggled buttons
        [
          { align: "" },
          { align: "center" },
          { align: "right" },
          { align: "justify" }
        ],
        ["blockquote", "code-block"],
        [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
        [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
        [{ color: [] }, { background: [] }], // dropdown with defaults from theme
        ["link", "image"], // Can add - "video"
        ["clean"] // remove formatting button
      ],
      processing: false,
      templateVariables: [
        {name: "Customer Firstname", value: "{customer_firstname}"},
        {name: "Customer Lastname", value: "{customer_lastname}"},
        {name: "Customer Email", value: "{customer_email}"},
        {name: "Order No.", value: "{order_no}"},
        {name: "Order Items", value: "{order_items}"},
        {name: "Date of Purchase", value: "{date_of_purchase}"},
        {name: "Store Name", value: "{store_name}"},
      ],
      processing: false
    }
  },
  methods: {
    modalClosed(){
      console.log('modal closed')
    },
    exitModal(){
       this.showMyModal = false;
       let bodyTag = document.querySelector('body');
       let htmlTag = document.querySelector('html');
       bodyTag.style.overflowY = 'scroll';
       htmlTag.style.overflowY = 'scroll';
    },
    async sendNotification(){

      if((this.sendTestNotification && !this.test.email) && (this.sendTestNotification &&  (!this.test.phone || !this.test.countryCode))){
        this.$toasted.show(
          "Test email or phone is required",
          {
            type: "error",
            duration: 3000,
            action: {
              text: "Close",
              class: "toastBtnTxt",
              onClick: (e, toastObject) => {
                toastObject.goAway(0);
              },
            },
          }
        );
        return false;
      }

       if(!this.emailBody && !this.smsBody){
         this.$toasted.show(
          "At least one field is required. Email or SMS",
          {
            type: "error",
            duration: 3000,
            action: {
              text: "Close",
              class: "toastBtnTxt",
              onClick: (e, toastObject) => {
                toastObject.goAway(0);
              },
            },
          }
        );
        return false;
       }
       try{
         this.processing = true;
         const notificationStatus = await CustomCustomerNotification.sendNotification(this.list.value, this.emailBody, this.emailSubject, this.smsBody, {isTest: this.sendTestNotification, testData: this.test});
         console.log(notificationStatus.data)
         this.processing = false;

         this.$toasted.show(
          notificationStatus.data.message,
          {
            type: "success",
            duration: 3000,
            action: {
              text: "Close",
              class: "toastBtnTxt",
              onClick: (e, toastObject) => {
                toastObject.goAway(0);
              },
            },
          }
        );

        if(!this.sendTestNotification){
          this.resetForm();
        }
        

       }
       catch(e){
         console.log("Send notification request status", e)
         this.processing = false;
       }

    },
    resetForm(){
      this.emailBody = "";
      this.smsBody = ""
    }
  },
  components: {VueEditor},
  beforeDestroy(){
    EventBus.$off('show-custom-notification-modal')
  }
}
</script>

<style lang="scss" scoped>
.dynamic-data{
  padding-left: 0;
  list-style-type: none;

  li{
    display: inline-block;
    padding: 5px 10px;
    border: 1px solid rgb(76, 167, 252);
    color:  rgb(76, 167, 252);
    font-size: 13px;
    margin-right: 5px;
    margin-bottom: 5px;
    border-radius: 5px;
    cursor: pointer;
    transition: all 300ms ease;
    &:hover{
      background-color:  rgb(76, 167, 252);
      color: #fff;
    }
  }
}

.myModal
{
  position: fixed;
  width: 100%;
  height: 100vh;
  left: 0;
  top: 0;
  z-index: 1004;
  transform-origin: 90% 30%;
  .myModalBodyOuter{
    position: fixed;
    width: 100%;
    height: 100vh;
    left: 0;
    top: 0;
    z-index: 1006;
    overflow-y: scroll;
  }

  .myModalOverlay{
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: 100%;
    background-color: rgba(43, 75, 99, 0.5);
    z-index: 1005;
  }
  .myModalBody{
    
   position: absolute;
   width: 700px;
   left: 50%;
   transform: translate(-50%, 0);
   top: 100px;
   z-index: 1007;
   background-color: #fff;
   padding: 30px;
   margin-bottom: 50px;
   border-radius: 10px;
   box-shadow: 2px 2px 5px rgba(0,0,0,0.2),-2px -2px 5px rgba(0,0,0,0.2);
  }
}

.zoom-enter-active, .zoom-leave-active {
  transition: all 0.3s;
}
.zoom-enter, .zoom-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: scale(0);
}

</style>
